module.exports = __webpack_public_path__ + "static/media/childcare.f06e9b47.svg";